<div *ngFor="let row of numberOfRowsArray; let last = last">
  <div class="flex justify-start animate-pulse py-8" [ngClass]="{ 'border-b border-grey': !last }">
    <div class="w-2/6 h-16 bg-slate-100 rounded-xl mr-10"></div>
    <div class="w-1/6 h-16 bg-slate-100 rounded-xl mr-10"></div>
    <div class="w-2/6 h-16 bg-slate-100 rounded-xl mr-10"></div>
    <div class="w-1/6 h-16 bg-slate-100 rounded-xl"></div>
  </div>
</div>
